type EventType = 'gridsReady' | 'editablesReady';

export const dispatch = (type: EventType) => {
  document.dispatchEvent(new Event(type));
};

export const listen = (type: EventType, handler: () => void | Promise<void>) => {
  document.addEventListener(type, handler);
};
